/**
 * This functon creates ownership array containing owner objects having details - organizationId, userId, isPrimary
 * @param orgId
 * @param ownerId
 * @param coOwnerIds
 * @returns {[]}
 */
export default function makeOwnerships(orgId, ownerId, coOwnerIds) {
  let ownerships = []
  if (ownerId) {
    ownerships.push({ organizationId: orgId, userId: ownerId, isPrimary: true })
  }
  coOwnerIds.forEach(coOwnerId => {
    ownerships.push({ organizationId: orgId, userId: coOwnerId, isPrimary: false })
  })
  return ownerships
}
